<template>
    <div>
        <v-data-table
        :headers="headers"
        :items="items"
        >
        <template v-slot:item.specialColumn="{ item }">
            <td :style="{ backgroundColor: 'red', color: 'white' }">{{ item.specialColumn }}</td>
        </template>
        
        <template class="fundo-tabela" v-slot:item="{ item }">
            <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.age }}</td>
            <td>{{ item.city }}</td>
            <!-- Replace 'specialColumn' with the actual name of your column -->
            <td>{{ item.specialColumn }}</td>
            </tr>
        </template>
        </v-data-table>
    
    </div>
  </template>  
  
  <script>
  export default {
    name: "TabelaPrazosComponent",
    data() {
      return {
        headers: [
          { text: 'Name', value: 'name' },
          { text: 'Age', value: 'age' },
          { text: 'City', value: 'city' },
          { text: 'Special Column', value: 'specialColumn' }
        ],
        items: [
          { name: 'Alice', age: 30, city: 'New York', specialColumn: 'Important' },
          { name: 'Bob', age: 25, city: 'Los Angeles', specialColumn: 'Urgent' },
          // Add more items as needed
        ]
      };
    }
  };
  </script>
  